import { render, staticRenderFns } from "./monitoring5Detail.vue?vue&type=template&id=18821887"
import script from "./monitoring5Detail.vue?vue&type=script&lang=js"
export * from "./monitoring5Detail.vue?vue&type=script&lang=js"
import style0 from "./monitoring5Detail.vue?vue&type=style&index=0&id=18821887&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports